var exports = {
  "C9": "NekoSprite.module__neko___R25pR0",
  "Hm": "NekoSprite.module__heart___R25pR0",
};

module.exports = exports;
